import lodash from 'lodash';
import moment from 'moment';

export const DOA_TYPE_TASK = 'doa';
export const EVENT_TYPE_TASK = 'event';
export const SDFA_TYPE_TASK = 'sdfa';


export function getRecipientDisplayName(recipient) {
    if (typeof recipient === 'object') {
        return lodash.get(recipient, 'displayName', '');
    }
    return recipient;
}

export const getTasksRecipientsWithPendingSignatures = (pendingTasks) => {
    return pendingTasks.map((pendingTask) => {

        const activeTasks = pendingTask.tasks.filter(task => !task.deleted);
        const taskRecipients = pendingTask.tasks.map(task => {
            if (!task.finished && !task.deleted) {
                return lodash.get(task, 'recipient.displayName', '');
            }
        });

        const formattedPendingTask = {
            ...pendingTask,
            recipients: lodash.without(taskRecipients, undefined),
            activeTasks,
        };

        return formattedPendingTask;
    });
};

export const getTasksRecipientsWithCompletedSignatures = (completedTasks) => {
    return completedTasks.map(completedTask => {
        const finishedTasks = lodash.filter(completedTask.tasks, task =>
            task.finished && !task.deleted
        );

        const taskRecipients = finishedTasks.map(task => lodash.get(task, 'recipient.displayName', ''));

        const formattedTask = {
            ...completedTask,
            task: finishedTasks,
            recipients: taskRecipients
        };

        return formattedTask;
    });

};


export function assignTasksByCategory(tasks, status,) {
    let assignedTasks = lodash.filter(tasks, ['status', status]);

    if (status == 'Incomplete') {
        assignedTasks = pendingTasksDisplay(assignedTasks);
    } else if (status == 'Complete') {
        assignedTasks = completedTasksDisplay(assignedTasks);
    }
    return assignedTasks;
}

function pendingTasksDisplay(tasks) {
    tasks.map((task, i) => {
        tasks[i].completePercentage = parseFloat(task.completedInstances / (parseInt(task.completedInstances) + parseInt(task.activeInstances)));
        tasks[i].daysSinceAssigned = parseInt(getDiffDays(task.sentDate));
    });
    return tasks;
}

function completedTasksDisplay(tasks) {
    const completedTasks = tasks.map(task => {
        const finishedSubTasks = lodash.filter(task.tasks, ['finished', true]);
        return {
            ...task,
            finishedTask: finishedSubTasks.length
        };
    });

    return completedTasks;
}

function getDiffDays(sentDate) {
    let sent = moment(sentDate, 'YYYY-MM-DDTHH:mm:ssZ');

    let objSentDate = getDateFormat(sent);
    let objToday = getDateFormat(moment());

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    let firstDate = new Date(objSentDate.year, objSentDate.month, objSentDate.day);
    let secondDate = new Date(objToday.year, objToday.month, objToday.day);

    return Math.round(
        Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
    );

}

function getDateFormat(momentItem) {
    return {
        day: momentItem.format('DD'),
        month: momentItem.format('MM'),
        year: momentItem.format('YYYY')
    };
}
